<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="450")

    template(v-slot:activator="{ on, attrs }")
      v-icon(
          slot="activator" 
          small 
          title='Resend Approval' 
          color="orange darken-2" 
          v-bind="attrs"
          v-on="on"
          class="mr-2"
        ) send

    v-card(class="pa-5")
      v-icon(class="notif") notifications
      v-card-title(class="headline") Resend Approval
      v-card-text Resend imemo only available 1 time/day for the same approver.

      v-card-actions( v-if="!loadingDialog" class="mt-5")
        v-spacer

        v-btn(
            @click="dialog = false"
            class="custom__padding-btn elevation-0 mr-2"
        ) NO
        v-btn(
            color="blue-secondary",
            @click="submit"
            class="elevation-0 custom__padding-btn"
        ) YES

      v-card( v-if="loadingDialog" color="primary" dark)
        v-card-text Processing. Please wait!
          v-progress-linear(indeterminate color="blue" class="mb-0")
    //- v-dialog(v-model="loadingDialog"  width="300")
    //-   v-card(color="primary" dark)
    //-     v-card-text Please stand by

    //- v-overlay(:value="overlay")
    //-   v-progress-circular(
    //-     indeterminate
    //-     size="64"
    //-   )

</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: 'ResendNotif',
  props: {
    imNo: String,
  },
  data: () => ({
    dialog: false,
    // overlay: false,
    // loading: true,
    loadingDialog: false
  }),
  methods: {
    submit() {
        // this.loading = true;  // Set loading to true when the submission starts
        this.loadingDialog = true;  // Show the loading dialog

        this.$store
            .dispatch("resendNotif", { imNo: this.imNo })
            .then((res) => {
                if( res.data.status == 400 ) {
                  this.$toasted.error(res.data.message, { icon : 'error'});
                  this.dialog = false
                } else if ( res.data.status == 403 ) {
                  this.$toasted.error(res.data.message, { icon : 'error'});
                  this.dialog = false
                } else {
                  this.$toasted.success("Success, the approval was successfully resend via email and whatsapp", { icon : 'check_circle'});
                  this.dialog = false
                  location.reload();
                }
                // this.loading = false
                this.loadingDialog = false
            }).catch((err) => {
                this.$toasted.error(err.response.error, { icon: 'error' });
                this.dialog = false
                this.loadingDialog = false
                // alert("Failed to Resent")
                //- location.reload();
            });
    }
  }
};
</script>

<style>
    i.notif{
        margin-left: 1rem;
        font-size: 50px !important;
        color: #1976D2 !important;
    }
</style>